import { React, useState, useEffect } from 'react'
import { OverlayTrigger, Tooltip, Form } from 'react-bootstrap';
import api from '../../../seller-apis/api';
import { NavLink } from 'react-router-dom';
import PaginationCom from '../../common/Pagination';
import NotAprrPCard from '../../common/NotAprrPCard';
import '../../inventry.css'
import { pendingProducts } from '../../../seller-apis/apidataField';
import Popup from '../../common/Popup';
import { variables } from '../../../Variables.json';
import moment from 'moment';
import ProductSearch from '../../common/ProductSearch';
var globalFilter = {
    "pageNo": 1,
    "filters":{"status":"pending"}
};
const AddManual = () => {

    var outerdiv;
    var loaderDiv;

    const [pendingProductsList, setpendingProductsList] = useState([]);
    const [pendRecords, setpendRecords] = useState();

    // Pagination related
    const [selPgPend, setselPgPend] = useState(1);
    const [compforPaginationweb, setcompforPaginationweb] = useState("default")

    // Web search

    const [searchPro, setsearchPro] = useState();

    // Loader

    const [loaderProduct, setloaderProduct] = useState("block")
    const [searchType, setSearchType] = useState("Product Name");


    // Detail Popup

    const [isDetailPopupVis, setisDetailPopupVis] = useState("none")
    const [currdetailId, setcurrdetailId] = useState(0)
    
    const [removeFilterClass, setremoveFilterClass] = useState("invent_remove_filter_btn")
    const [currstatussort, setcurrstatussort] = useState("all")

    useEffect(() => {
        globalFilter = {
            "pageNo": 1,
            "filters":{"status":"pending"}
        }

        // Pending products
        api.product.newProductsRetrieveall(pendingProducts(globalFilter))
            .then((res) => {
                setpendingProductsList(res.products)
                setpendRecords(res.totalRecords)
                setloaderProduct("none")
            })
            .catch(err => console.log(err))


    }, [])


    // Sort according to status

    function statussort(e) {
        applyLoader()
        setcurrstatussort(e.value)
        globalFilter.pageNo = 1;
        if (e.value == "all" && globalFilter.filters && globalFilter.filters.status) {
            delete globalFilter.filters.status;
        } else {
            globalFilter.filters = {
                ...globalFilter.filters, "status": e.value
            }
        }
        api.product.newProductsRetrieveall(pendingProducts(globalFilter))
            .then((res) => {
                setpendingProductsList(res.products)
                setpendRecords(res.totalRecords)
                removeLoader()
            })
            .catch(err => console.log(err))
    }

    // Search on enter web

    function checkevent(e) {
        if (e.keyCode === 13) {
            globalFilter.filters = {
                ...globalFilter.filters, "productName": searchPro,
            }
            if (searchPro !== undefined && searchPro !== "") {
                let ordersearchFilter=searchType!='sku'?{"productName": searchPro}:{"SKU": searchPro};
                globalFilter.filters = {
                    ...ordersearchFilter,
                }
                applyLoader()
                setselPgPend(1)
                setcompforPaginationweb("filter")
                globalFilter.pageNo = "1"
                api.product.newProductsRetrieveall(pendingProducts(globalFilter))
                    .then((res) => {
                        setremoveFilterClass("invent_remove_filter_btn_active")
                        setpendingProductsList(res.products)
                        setpendRecords(res.totalRecords)
                        removeLoader()
                    })
                    .catch(err => console.log(err))
            }
            else if (compforPaginationweb !== "default") {
                applyLoader()
                globalFilter.pageNo = "1"
                globalFilter.filters = {}
                setselPgPend(1)
                api.product.newProductsRetrieveall(pendingProducts(globalFilter))
                    .then((res) => {
                        setremoveFilterClass("invent_remove_filter_btn")
                        setcompforPaginationweb("default")
                        setpendingProductsList(res.products)
                        setpendRecords(res.totalRecords)
                        removeLoader()
                    })
                    .catch(err => console.log(err))
            }
        }
    }

    // search product btn web
    function searchProdBtnweb() {
        globalFilter.filters = {
            ...globalFilter.filters, "productName": searchPro,
        }
        if (searchPro !== undefined && searchPro !== "") {

            applyLoader()
            setselPgPend(1)
            setcompforPaginationweb("filter")
            globalFilter.pageNo = "1"
            api.product.newProductsRetrieveall(pendingProducts(globalFilter))
                .then((res) => {
                    setremoveFilterClass("invent_remove_filter_btn_active")
                    setpendingProductsList(res.products)
                    setpendRecords(res.totalRecords)
                    removeLoader()
                })
                .catch(err => console.log(err))
        }
        else if (compforPaginationweb !== "default") {
            applyLoader()
            globalFilter.pageNo = "1"
            globalFilter.filters = {}
            setselPgPend(1)
            api.product.newProductsRetrieveall(pendingProducts(globalFilter))
                .then((res) => {
                    setremoveFilterClass("invent_remove_filter_btn")
                    setcompforPaginationweb("default")
                    setpendingProductsList(res.products)
                    setpendRecords(res.totalRecords)
                    removeLoader()
                })
                .catch(err => console.log(err))
        }
    }

    // Pagination function

    function paginate(data) {
        setcurrdetailId(0)
        globalFilter.pageNo = data.number
        setselPgPend(data.number)
        applyLoader()
        api.product.newProductsRetrieveall(pendingProducts(globalFilter))
            .then((res) => {
                setpendingProductsList(res.products)     
                removeLoader()   
            })
            .catch(err => {
                console.log(err)
                removeLoader()
            })
    }

    
    // apply loaders

    function applyLoader() {
        outerdiv = document.getElementById("orDeskContain");
        loaderDiv = document.getElementById("Loaderrejected");
        loaderDiv.classList.add("loader-bt");
        setloaderProduct("flex")
        outerdiv.classList.add("div-bk");
    }

    // remove loader

    function removeLoader() {
        loaderDiv.classList.remove("loader-bt");
        setloaderProduct("none")
        outerdiv.classList.remove("div-bk");
    }


    // Show detail

    function showDetail(id) {
        setcurrdetailId(id)
        setisDetailPopupVis("block")
    }

    function setpopupVisibilityDetail() {
        setisDetailPopupVis("none")
    }
    
    // Clear Filters

    function clearFilters() {
        if (searchPro !== undefined && searchPro !== "") {
            applyLoader()
            setselPgPend(1)
            globalFilter = {
                "pageNo": "1",
                "filters":{"status":"pending"}
            }
            setsearchPro("")
            api.product.newProductsRetrieveall(pendingProducts(globalFilter))
            .then((res) => {
                setpendingProductsList(res.products) 
                setremoveFilterClass("invent_remove_filter_btn") 
                setpendRecords(res.totalRecords)
                setcompforPaginationweb("default")
                removeLoader()   
            })
            .catch(err => {
                console.log(err)
                removeLoader()
            })

        }
    }
    const filterSearch=(data)=>{
        setsearchPro(data.data);
        setSearchType(data.type)
      }
    
      useEffect(()=>{
        checkevent({ "keyCode": 13 }, "appPro");
      },[searchPro])
      const searchParam ={
        "status": "pending"
    }
    return (
        <div className=" inventry-page" id="outer">
            <div className='pro_filt_cntnier_new_request d-flex'>
            {/* <button className={removeFilterClass} onClick={() => clearFilters()}>Clear Filter</button> */}
            <div className='topprodsearch'>
                {/* <ProductSearch 
                filterSearch={filterSearch}
                searchNewEnq={setsearchPro}
                searchParam={searchParam}
                /> */}
          </div>
            {/* <div class="">
                      <select className="pro_approved_srch_bar pr-4" onChange={(e)=>{setSearchType(e.target.value)}}>
                        <option value="product Name">Product Name</option>
                        <option value="sku">SKU</option>
                      </select>
                    </div>
                <input type='text' value={searchPro} placeholder='Search for products...' className='pro_approved_srch_bar pr-4' onKeyUp={(e) => checkevent(e)} onChange={(e) => setsearchPro(e.target.value)}></input><i className="fa fa-search srch_pro_filt_invent" aria-hidden="true" onClick={() => searchProdBtnweb()}></i> */}

                <NavLink exact to="/add-Product1">
                    <button className='pro_add_pro_invent ms-2'>+ Add Product</button>
                </NavLink>
                
            </div>

            <div className="container_invent" id="orDeskContain">


                {/* New orders desktop */}
                <div class="tab table-responsive">
                    {/* <Container> */}



                    <table className='ord_table' style={{ "width": "100%" }}>
                        <thead>
                            <tr className='table_ord_title_row'>

                                <th className='thead_title pt-2 pb-2' style={{ "width": "5%" }}>Product Image

                                </th>

                                <th className='thead_title pb-1' style={{ "width": "20%" }}>Product Name<br></br>

                                </th>

                                <th className='thead_title' style={{ "width": "7%" }}>Transfer price  <OverlayTrigger
                                    key="transfer"
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id={`tooltip-transfer`} className="fs-10 order_page_tooltip">
                                            <p className='fs-8 f-500 order_page_tooltip_1'>{variables.transferPriceText}</p>
                                        </Tooltip>
                                    }
                                >
                                    <i class="bi bi-info-circle ms-1"></i>
                                </OverlayTrigger></th>

                                <th className='thead_title' style={{ "width": "10%" }}>Requested On</th>

                                <th className='thead_title' style={{ "width": "10%" }}>Action
                                    <br></br>
                                    <Form.Select size="lg" className="pro_card_comb_box_invent mb-1" style={{ "width": "90%" }} onChange={(e) => statussort(e.target)} value={currstatussort}>
                                        <option value="all">All</option>
                                        <option value="pending">Pending</option>
                                        <option value="rejected">Rejected</option>
                                    </Form.Select>
                                    <br></br>
                                </th>
                            </tr>

                        </thead>
                        <tbody>
                            {pendRecords > 0 ? pendingProductsList && pendingProductsList.map((item, index) => {
                                let baseImg;
                                item.images && item.images.map((item) => {
                                    if (item.baseImage === true) {
                                        if (item.image.startsWith("products")) {
                                            baseImg = item.image;
                                        }
                                        else if (item.image.startsWith("https:")) {
                                            let img = item.image.substr("41")
                                            baseImg = img;
                                        }
                                        else {
                                            baseImg = item.image;
                                        }
                                    }

                                })
                                let date = new Date(item.updatedAt);
                                let d = date.toUTCString(item.updatedAt);
                                let newd = d.substr(4, 12);
                                let actionDate = moment(item.actionDate).format("D, MMM YYYY, h:mm:ss a");
                                return (
                                    <NotAprrPCard id={index}
                                        taxClass={item.taxClass}
                                        lead={item._id}
                                        productName={item.productName}
                                        price={item.price}
                                        quantity={item.quantity}
                                        status={item.status}
                                        image={baseImg}
                                        weight={item.weight}
                                        date={newd}
                                        detail={showDetail}
                                        remark={item.remark}
                                        actionDate={actionDate}
                                    />
                                )
                            }) : loaderProduct === "block" ? <></> :
                                <div className="card card-1">
                                    Nothing here
                                </div>
                            }


                        </tbody>
                    </table>
                    {/* </Container> */}
                </div>
                <PaginationCom
                    number={pendRecords}
                    paginate={paginate}
                    comp="pendingPro"
                    activ={selPgPend}
                />
                <div class="d-flex justify-content-center loader-bt" id="Loaderrejected">
                    <div class="spinner-border" role="status" style={{ "display": loaderProduct }}>
                        <span class="sr-only"></span>
                    </div>
                </div>

                {/* Detail popup */}
                {pendingProductsList && pendingProductsList.length > 0 ? <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
                    <Popup
                        description={pendingProductsList[currdetailId].description}
                        sdescription={pendingProductsList[currdetailId].shortDescription}
                        descriptionNew={pendingProductsList[currdetailId].product?.descriptionNew||[]}
                        specificationNew={pendingProductsList[currdetailId].product?.specificationNew||[]}
                        name={pendingProductsList[currdetailId].productName}
                        // price={detailPPrice}
                        // SKU={pendingProductsList[currdetailId].product.SKU}
                        from="manualProducts"
                        popupVisibility={setpopupVisibilityDetail}
                        images={pendingProductsList[currdetailId].images}
                    />
                </div> : <></>
                }

            </div>


        </div>
    )
}

export default AddManual